<button class="close" mat-button (click)="close()">X</button>
<h3 mat-dialog-title>Add a board member.</h3>
<mat-dialog-content class="change-bg">
  <form [formGroup]="phoneNumberEntered" >
    
    <mat-form-field appearance="fill">
      <mat-label>Phone</mat-label>
      <input matInput formControlName="phone" required placeholder="Type User Number to Add as Board Member" (ngModelChange)="onPhoneNochange($event)">
    </mat-form-field>
    <br><br>
  </form>
  <mat-spinner style="margin: auto;" *ngIf="showSpinner" ></mat-spinner>


  <div class="mat-elevation-z8" [hidden]="showSpinner">
    <mat-table #table [dataSource]="dataSource" (scroll)="onTableScroll($event)">

        <ng-container matColumnDef="first_name">
          <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.first_name | titlecase}} {{element.last_name}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="division">
          <mat-header-cell *matHeaderCellDef> Division </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.division}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef> Phone </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.phone}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef> Add </mat-header-cell>
          <mat-cell *matCellDef="let element"> <mat-icon (click)="createBoardMember(element)">add</mat-icon> </mat-cell>
        </ng-container> 

         <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns; let i= index" (click)="selectedRow(row)"
        [ngClass]="{'highlightTableColor': selectedRowIndex == i}"></mat-row>
        
    </mat-table>
  </div>
  <br><br>

  
</mat-dialog-content>